var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 446,
    height: 351,
    viewBox: "0 0 446 351",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M336.645 117.007H435.011C433.077 109.8 425.084 104.78 419.025 109.285C421.99 99.5038 415.415 87.7922 405.488 85.3469C395.561 82.773 384.216 89.7227 381.896 99.7612C379.317 95.7715 373.387 94.6133 369.39 97.0585C365.394 99.6325 364.233 105.553 366.683 109.542C362.429 105.167 355.725 103.236 349.794 104.78C343.993 106.196 338.192 111.087 336.645 117.007Z",
    fill: "url(#paint0_linear_10618_8149)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M396.588 291.522H305.055C305.57 284.701 307.633 277.365 312.145 272.346C316.658 267.198 323.361 263.981 330.194 264.624C337.027 265.268 343.344 270.416 344.633 277.108C346.18 274.019 350.048 272.346 353.4 273.376C356.623 274.405 358.943 278.009 358.428 281.355C358.686 275.435 365.132 270.544 370.933 271.96C376.734 273.376 380.086 280.84 377.508 286.245C380.344 283.414 384.598 282.256 388.466 283.157C392.205 284.186 395.428 287.79 396.588 291.522Z",
    fill: "url(#paint1_linear_10618_8149)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M115.416 140.172H189.158C188.772 134.767 187.096 128.847 183.486 124.6C179.876 120.481 174.333 117.779 168.918 118.422C163.503 118.937 158.346 123.055 157.315 128.46C156.026 126.015 152.932 124.6 150.224 125.5C147.517 126.273 145.712 129.233 146.099 131.935C145.97 127.174 140.684 123.184 136.043 124.342C131.402 125.5 128.566 131.549 130.758 135.796C128.437 133.48 124.956 132.579 121.862 133.351C118.897 134.123 116.318 137.083 115.416 140.172Z",
    fill: "url(#paint2_linear_10618_8149)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M182.325 243.774C182.325 243.774 147.258 242.101 131.272 246.734C115.415 251.367 52.502 300.015 52.502 300.015C52.502 300.015 146.872 297.441 157.314 291.907C167.757 286.373 191.091 263.851 191.091 263.851L182.325 243.774Z",
    fill: "url(#paint3_linear_10618_8149)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M184.644 248.407C184.644 248.407 166.209 247.506 157.829 249.951C149.449 252.397 116.316 278.008 116.316 278.008C116.316 278.008 165.951 276.721 171.494 273.761C177.038 270.801 189.285 258.96 189.285 258.96L184.644 248.407Z",
    fill: "url(#paint4_linear_10618_8149)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M218.289 210.57L187.348 207.095L146.867 231.033C146.867 231.033 149.059 234.379 151.895 234.765C154.731 235.152 182.707 227.687 182.707 227.687L187.864 235.538C187.864 235.409 219.836 226.529 218.289 210.57Z",
    fill: "url(#paint5_linear_10618_8149)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M241.106 262.822L222.67 287.789L177.677 301.174C177.677 301.174 176.646 297.313 178.322 294.996C179.998 292.68 204.493 277.236 204.493 277.236L202.172 268.098C202.043 268.227 230.406 250.853 241.106 262.822Z",
    fill: "url(#paint6_linear_10618_8149)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M344.117 152.656L356.106 219.321C354.172 220.608 352.11 221.895 349.918 223.182C348.113 224.341 346.179 225.37 344.246 226.529C342.054 227.816 339.862 228.974 337.542 230.132C332.901 232.577 328.002 234.894 322.845 237.211C256.193 266.296 201.918 268.227 201.918 268.227L187.607 235.537C187.607 235.537 225.897 197.185 292.677 168.228C297.834 166.04 302.862 163.981 307.89 162.179C310.34 161.278 312.66 160.506 315.11 159.734C317.172 159.09 319.364 158.447 321.427 157.803C329.42 155.616 336.897 153.943 344.117 152.656Z",
    fill: "#FFF3C5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M422.371 152.784C422.114 153.428 402.776 188.176 358.814 217.52L346.953 152.141C390.915 144.805 422.371 152.784 422.371 152.784Z",
    fill: "#FFF3C5"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M422.372 152.784C422.372 152.784 400.585 192.552 350.048 223.054L321.557 157.803C378.282 141.587 422.372 152.784 422.372 152.784Z",
    fill: "url(#paint7_linear_10618_8149)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M315.241 159.734L344.377 226.4C342.185 227.687 339.994 228.845 337.673 230.004L308.021 162.051C310.471 161.279 312.792 160.506 315.241 159.734Z",
    fill: "url(#paint8_linear_10618_8149)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M178.068 239.656L187.866 235.409L202.048 268.227L192.379 272.474L178.068 239.656Z",
    fill: "url(#paint9_linear_10618_8149)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M161.438 263.336L162.598 265.91L163.758 268.484L231.57 243.259C234.535 238.369 231.699 231.934 226.155 230.776L161.438 263.336Z",
    fill: "url(#paint10_linear_10618_8149)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M422.372 152.784C421.985 153.428 400.198 192.809 350.177 223.054C348.372 224.212 346.438 225.242 344.504 226.4C342.313 227.687 340.121 228.845 337.8 230.003C333.159 232.449 328.26 234.765 323.103 237.082C256.452 266.168 202.176 268.098 202.176 268.098L198.18 259.089C217.776 254.971 270.891 247.12 319.107 226.142C356.623 209.798 421.341 153.685 422.372 152.784Z",
    fill: "#F7D79F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M422.369 152.784C421.725 152.655 377.892 141.844 321.554 157.803C319.491 158.447 317.428 159.09 315.237 159.734C312.787 160.506 310.466 161.278 308.017 162.179C302.989 163.981 297.961 165.911 292.804 168.099C226.153 197.185 187.734 235.408 187.734 235.408L191.731 244.417C208.104 232.834 249.874 199.373 298.219 178.395C335.735 162.05 420.951 152.913 422.369 152.784Z",
    fill: "#FDFCEC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M226.413 206.709C226.413 206.709 222.545 216.49 222.545 217.648C222.545 218.806 223.576 221.509 224.479 222.153C225.381 222.667 230.667 219.579 231.054 218.806C231.44 218.034 232.987 206.709 232.987 206.709H226.413Z",
    fill: "#502F12"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M281.976 181.999L289.969 179.167C290.356 179.811 291.516 181.999 292.547 182.771C293.837 183.672 298.349 185.087 299.509 185.473C300.283 185.731 300.154 186.889 300.154 186.889L281.589 188.047C281.46 188.176 281.46 184.315 281.976 181.999Z",
    fill: "#502F12"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M234.534 125.757L225.252 207.481C225.252 207.481 230.409 208.897 233.632 207.352C233.632 207.352 252.067 148.923 253.614 142.746C253.614 142.746 279.398 146.092 283.653 145.062C283.653 145.062 281.461 180.712 281.332 182.127C281.332 182.127 287.778 180.583 290.357 180.197C290.357 180.197 296.029 135.281 295.514 133.994C294.869 132.836 272.824 129.103 272.824 129.103L234.534 125.757Z",
    fill: "url(#paint11_linear_10618_8149)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M208.878 123.956L204.366 122.669C201.916 121.897 199.338 123.313 198.565 125.758L197.662 128.589L199.467 129.104L200.369 126.273C200.756 124.857 202.303 124.085 203.721 124.471L208.234 125.758C209.652 126.144 210.425 127.689 210.038 129.104L209.136 131.936L210.941 132.45L211.843 129.619C212.617 127.302 211.328 124.728 208.878 123.956Z",
    fill: "#331D11"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M197.092 126.701L196.645 128.179L200.594 129.37L201.041 127.892L197.092 126.701Z",
    fill: "#FFF3C5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M210.682 127.044C210.424 127.173 210.296 127.43 210.038 127.43C209.522 127.688 209.135 127.688 209.135 127.688C209.135 127.688 207.201 130.519 206.557 130.776C205.912 131.034 203.463 129.103 202.947 128.717C202.431 128.331 200.24 125.886 199.853 124.728C199.466 123.569 204.107 116.748 204.107 116.748L211.714 120.223C211.843 120.094 211.456 126.401 210.682 127.044Z",
    fill: "#F8C3C5"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M210.168 127.43C209.652 127.688 209.266 127.688 209.266 127.688C209.266 127.688 209.266 126.143 209.137 126.015C209.008 125.886 208.621 124.856 208.621 124.856C208.621 124.856 209.652 123.183 209.781 123.312C209.91 123.441 210.039 124.342 210.039 124.342L209.652 125.629C209.781 125.629 210.168 126.658 210.168 127.43Z",
    fill: "#F1898E"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M226.41 139.656L217.902 167.841C217.515 169.128 216.097 169.9 214.808 169.514L174.069 157.288C172.78 156.902 172.006 155.486 172.393 154.199L180.902 126.014C181.288 124.727 182.706 123.955 183.996 124.341L224.735 136.567C226.024 136.953 226.797 138.369 226.41 139.656Z",
    fill: "#774411"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M219.449 162.436L217.773 167.841C217.386 169.128 215.968 169.9 214.679 169.514L173.94 157.288C172.651 156.902 171.877 155.486 172.264 154.199L173.94 148.794L219.449 162.436Z",
    fill: "#502F12"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M202.474 155.457L192.23 152.37L190.889 156.805L201.133 159.892L202.474 155.457Z",
    fill: "#FFF3C5"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M190.939 126.466L187.73 125.499L177.783 158.394L180.991 159.361L190.939 126.466Z",
    fill: "#331D11"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M221.133 135.462L217.924 134.495L207.976 167.39L211.185 168.357L221.133 135.462Z",
    fill: "#331D11"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M211.201 125.629C210.944 125.243 210.557 124.857 210.041 124.599C209.783 124.471 209.525 124.213 209.139 124.084C208.881 124.471 208.623 124.857 208.623 124.857C208.623 124.857 209.01 126.015 209.139 126.015V126.144C209.525 126.401 209.783 126.916 210.041 127.302C210.17 127.817 210.299 128.46 210.041 128.975L209.139 131.806L210.944 132.321L211.846 129.49C212.362 128.203 212.104 126.787 211.201 125.629Z",
    fill: "#331D11"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M208.627 130.087L208.18 131.565L212.129 132.755L212.576 131.277L208.627 130.087Z",
    fill: "#FFF3C5"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M328.393 64.3665L331.358 71.7023L326.846 74.6624L322.979 70.544L326.073 64.2378L328.393 64.3665Z",
    fill: "#F5AFB2"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M317.561 5.42313C315.628 7.7397 312.018 8.64059 308.924 8.64059C305.83 8.76929 302.864 7.8684 300.028 6.96751C297.192 6.06662 294.227 4.90833 291.262 4.52224C285.46 3.62134 279.53 5.16573 274.244 7.611C279.143 9.67018 283.784 12.3729 288.425 15.0755C283.913 18.293 279.659 22.5401 276.049 26.6584C281.335 25.114 286.62 27.0445 291.777 28.5889C297.063 30.1333 302.091 32.3212 307.377 33.3507C312.791 34.3803 318.593 34.2516 323.234 31.2916L317.561 5.42313Z",
    fill: "url(#paint12_linear_10618_8149)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M320.397 4.9082L346.954 152.14C346.052 152.268 345.021 152.526 344.118 152.654L317.561 5.423L320.397 4.9082Z",
    fill: "#430725"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M322.204 68.743L325.298 62.6941L334.451 62.5654C334.451 62.5654 335.096 63.8524 333.549 64.4959C332.131 65.1394 329.036 65.5255 329.036 65.5255C329.036 65.5255 326.458 72.0891 323.751 71.5743C321.172 70.8021 322.204 68.743 322.204 68.743Z",
    fill: "#F8C3C5"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M333.29 65.2675C333.29 65.2675 334.45 66.6832 334.063 67.5841C333.805 68.6136 328.52 69.2571 328.52 69.2571L328.004 68.0989C328.133 68.0989 331.872 64.624 333.29 65.2675Z",
    fill: "#F8C3C5"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M332.903 63.08C332.903 63.08 334.063 64.4957 333.676 65.3966C333.419 66.4261 328.133 67.0696 328.133 67.0696L327.617 65.9113C327.617 65.9113 331.356 62.4365 332.903 63.08Z",
    fill: "#F8C3C5"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M333.418 67.8416C333.418 67.8416 334.45 69.1286 334.192 69.9008C333.934 70.8017 329.293 71.4452 329.293 71.4452L328.777 70.2869C328.777 70.2869 332.129 67.1981 333.418 67.8416Z",
    fill: "#F8C3C5"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M333.291 70.4158C333.291 70.4158 333.936 71.574 333.678 72.3462C333.291 72.9897 329.424 72.861 329.424 72.861L329.166 71.9601C329.166 71.8314 332.389 69.7723 333.291 70.4158Z",
    fill: "#F8C3C5"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M264.83 79.9401C264.83 79.9401 266.119 80.7123 268.311 81.7419C274.499 84.8306 287.52 91.0082 293.579 90.8795C301.83 90.7508 328.517 76.4652 328.517 76.4652L327.228 73.7626L322.457 64.2388C322.457 64.2388 298.349 78.9105 294.997 77.3661C291.646 75.9504 267.666 63.9814 267.666 63.9814L264.83 79.9401Z",
    fill: "#006C9E"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M267.41 78.9102L268.313 81.7415C274.501 84.8303 287.522 91.0078 293.581 90.8791C301.832 90.7504 328.518 76.4649 328.518 76.4649L327.229 73.7622C323.104 76.0788 300.543 88.3052 294.097 88.3052C287.006 88.0478 267.41 78.9102 267.41 78.9102Z",
    fill: "#004C6F"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M201.66 116.362L211.2 121.253L213.392 122.411L226.671 95.3842L245.88 82.1282L246.009 79.1682L246.396 64.7539C246.396 64.7539 219.709 80.3264 215.97 87.6623L201.66 116.362Z",
    fill: "#006C9E"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M211.07 121.123L213.262 122.281L226.541 95.2546L245.75 81.9986L245.879 79.0386C243.3 80.7117 224.478 93.3241 224.091 94.4824C223.705 95.512 214.809 113.53 211.07 121.123Z",
    fill: "#004C6F"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M272.954 129.232L258.514 128.846H257.483L255.034 128.717H253.744L233.375 127.945L237.5 76.9801C237.5 76.9801 238.274 65.7833 251.682 62.5659C251.811 62.5659 251.94 62.5659 252.068 62.4372C252.455 62.3085 252.842 62.3085 253.1 62.1798C253.744 62.0511 254.518 61.9224 255.291 61.9224L259.804 62.0511L263.671 62.1798C263.671 62.1798 264.96 62.3085 266.765 63.2094C267.023 63.338 267.41 63.5954 267.797 63.7241C268.183 63.9815 268.441 64.1102 268.828 64.3676C271.922 66.6842 275.145 71.3174 275.145 80.5837C275.016 97.958 272.954 129.232 272.954 129.232Z",
    fill: "#006C9E"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M254.773 88.0497C254.644 88.8219 253.999 89.208 253.226 89.0793C252.452 88.9506 252.065 88.3071 252.194 87.5349C252.323 86.7627 252.968 86.3766 253.741 86.5053C254.386 86.7627 254.902 87.4062 254.773 88.0497Z",
    fill: "#004C6F"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M254.126 98.7314C253.997 99.5036 253.353 99.8897 252.579 99.761C251.806 99.6323 251.419 98.9888 251.548 98.2166C251.677 97.4444 252.321 97.0583 253.095 97.187C253.74 97.4444 254.255 98.0879 254.126 98.7314Z",
    fill: "#004C6F"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M253.482 110.571C253.353 111.343 252.708 111.73 251.935 111.601C251.161 111.472 250.774 110.829 250.903 110.056C251.032 109.284 251.677 108.898 252.45 109.027C253.095 109.284 253.611 109.928 253.482 110.571Z",
    fill: "#004C6F"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M262.123 81.7422L272.05 82.3857C272.05 82.3857 271.663 91.2659 271.405 91.7807C271.148 92.1668 267.022 93.8399 265.862 93.4538C264.702 93.0677 261.607 90.8798 261.607 90.8798L262.123 81.7422Z",
    fill: "#004C6F"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M252.846 56.002L255.424 64.4961L264.835 63.3378L263.159 58.0611L252.846 56.002Z",
    fill: "#F5AFB2"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M263.414 39.9136L267.539 58.1888L256.065 59.4758L251.94 55.7435L248.717 44.0319L263.414 39.9136Z",
    fill: "#F8C3C5"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M249.493 53.4274C249.493 53.4274 248.461 49.9525 250.524 49.4377C252.587 48.9229 253.747 51.1108 253.747 51.1108L251.555 44.9333C251.555 44.9333 265.865 45.4481 265.479 38.3696C265.092 31.2912 260.322 31.6773 258.259 32.3208C256.196 32.9643 255.423 35.4096 256.325 37.34C256.325 37.34 246.914 37.34 246.141 39.914C245.238 42.3593 246.785 44.6759 246.785 44.6759C246.785 44.6759 244.851 44.9333 244.851 47.7646C244.594 50.596 248.074 52.9126 249.493 53.4274Z",
    fill: "#502F12"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M255.035 52.3978C255.035 52.3978 251.297 46.0915 248.718 49.9525C247.042 52.6552 251.812 55.7439 251.812 55.7439L255.035 52.3978Z",
    fill: "#F8C3C5"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M268.313 50.3394L264.703 51.369L264.188 44.9341L268.313 50.3394Z",
    fill: "#F8C3C5"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M254.902 128.717L253.613 128.588L259.157 63.7242L260.059 63.4668L254.902 128.717Z",
    fill: "#004C6F"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M252.068 62.5661L256.065 69.5158L259.546 63.8531L262.511 69.9019L267.668 63.8531L266.636 63.3383C264.96 62.4374 263.542 62.3087 263.542 62.3087L259.675 62.18L255.162 62.0513C254.389 62.18 253.744 62.18 252.971 62.3087C252.842 62.3087 252.455 62.4374 252.068 62.5661Z",
    fill: "#004C6F"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M263.668 62.3084L259.801 62.1797L262.508 68.6146L266.762 63.338C264.958 62.4371 263.668 62.3084 263.668 62.3084Z",
    fill: "#006C9E"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M253.227 62.3077L256.192 68.3565L259.93 62.179L255.418 62.0503C254.645 62.0503 253.871 62.179 253.227 62.3077Z",
    fill: "#006C9E"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M259.802 62.1792L257.868 65.268L258.899 66.6837C257.223 70.9307 254 74.7917 249.875 76.9796C246.652 78.6526 243.171 79.5535 239.819 80.9692C236.467 82.3849 233.244 84.7015 232.084 88.0476L233.502 93.453L239.948 91.3938C241.108 88.305 243.945 86.2459 246.781 84.5728C249.617 82.8997 252.711 81.484 254.903 79.0387C257.868 75.8213 259.157 71.1881 260.06 66.8124L260.962 65.3967L259.802 62.1792Z",
    fill: "url(#paint13_linear_10618_8149)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M157.316 100.405C154.866 100.405 154.866 104.137 157.316 104.137C159.765 104.137 159.765 100.405 157.316 100.405Z",
    fill: "#F8A800"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M235.183 0.791504C232.733 0.791504 232.733 4.52377 235.183 4.52377C237.632 4.52377 237.632 0.791504 235.183 0.791504Z",
    fill: "#F8A800"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M355.077 37.9858C352.628 37.9858 352.628 41.7181 355.077 41.7181C357.527 41.7181 357.527 37.9858 355.077 37.9858Z",
    fill: "#F8A800"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M383.056 130.391C380.606 130.391 380.606 134.124 383.056 134.124C385.505 134.124 385.505 130.391 383.056 130.391Z",
    fill: "#F8A800"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M131.661 197.829C129.212 197.829 129.212 201.562 131.661 201.562C134.111 201.562 134.111 197.829 131.661 197.829Z",
    fill: "#F8A800"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3195 206.323C72.8701 206.323 72.8701 210.056 75.3195 210.056C77.769 210.056 77.769 206.323 75.3195 206.323Z",
    fill: "#F8A800"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M410.384 240.3C407.935 240.3 407.935 244.032 410.384 244.032C412.833 244.032 412.833 240.3 410.384 240.3Z",
    fill: "#F8A800"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M271.538 299.373C269.089 299.373 269.089 303.105 271.538 303.105C273.988 303.105 273.988 299.373 271.538 299.373Z",
    fill: "#F8A800"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M103.552 84.8315C101.102 84.8315 101.102 88.5638 103.552 88.5638C105.873 88.5638 106.001 84.8315 103.552 84.8315Z",
    fill: "#F8A800"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3059 22.9272C51.8564 22.9272 51.8564 26.6595 54.3059 26.6595C56.7554 26.6595 56.7554 22.9272 54.3059 22.9272Z",
    fill: "#F8A800"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M444.163 78.2681C441.714 78.2681 441.714 82.0003 444.163 82.0003C446.613 82.0003 446.613 78.2681 444.163 78.2681Z",
    fill: "#F8A800"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M424.181 10.4438C421.731 10.4438 421.731 14.1761 424.181 14.1761C426.63 14.1761 426.63 10.4438 424.181 10.4438Z",
    fill: "#F8A800"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M366.681 324.726C364.231 324.726 364.231 328.458 366.681 328.458C369.001 328.458 369.001 324.726 366.681 324.726Z",
    fill: "#F8A800"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M1.83711 294.739C-0.612372 294.739 -0.612372 298.472 1.83711 298.472C4.2866 298.472 4.2866 294.739 1.83711 294.739Z",
    fill: "#F8A800"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M120.702 346.477C118.253 346.477 118.253 350.209 120.702 350.209C123.152 350.209 123.152 346.477 120.702 346.477Z",
    fill: "#F8A800"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10618_8149",
    x1: 385.815,
    y1: 58.3831,
    x2: 385.815,
    y2: 153.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDE5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAC495",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10618_8149",
    x1: 350.802,
    y1: 242.443,
    x2: 350.802,
    y2: 322.407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDE5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAC495",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10618_8149",
    x1: 152.354,
    y1: 100.535,
    x2: 152.354,
    y2: 165.019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDE5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAC495",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10618_8149",
    x1: 58.7154,
    y1: 299.119,
    x2: 190.457,
    y2: 253.221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF198"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7A418"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_10618_8149",
    x1: 127.597,
    y1: 275.101,
    x2: 192.849,
    y2: 251.739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF198"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7A418"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_10618_8149",
    x1: 149.938,
    y1: 237.988,
    x2: 217.362,
    y2: 208.521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84912C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007E3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_10618_8149",
    x1: 174.485,
    y1: 294.161,
    x2: 241.909,
    y2: 264.695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84912C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007E3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_10618_8149",
    x1: 335.805,
    y1: 190.466,
    x2: 422.283,
    y2: 152.672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84912C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007E3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_10618_8149",
    x1: 303.283,
    y1: 191.122,
    x2: 348.943,
    y2: 198.579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#547B96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A516F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_10618_8149",
    x1: 196.779,
    y1: 251.021,
    x2: 183.84,
    y2: 256.676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#547B96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A516F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_10618_8149",
    x1: 162.597,
    y1: 265.907,
    x2: 232.025,
    y2: 235.565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84912C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007E3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_10618_8149",
    x1: 260.066,
    y1: 185.795,
    x2: 261.993,
    y2: 117.226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06141B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A516F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_10618_8149",
    x1: 273.498,
    y1: 12.9892,
    x2: 325.036,
    y2: 21.4053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84912C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007E3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_10618_8149",
    x1: 264.73,
    y1: 57.2191,
    x2: 231.846,
    y2: 97.675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF198"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7A418"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlight);
export default __webpack_public_path__ + "static/media/flight.092c66cb602fec2c4c8902c2339fbd18.svg";
export { ForwardRef as ReactComponent };